import { FileContent, FileContentFactory } from ".."

export interface CreateNews {
    isDraft: boolean
    isActive: boolean
    names: {
        [key: string]: string
    }
    descriptions: {
        [key: string]: string
    }
    link: string
    image: FileContent
}

export class CreateNewsFactory {
    static create(): CreateNews {
        return {
            isDraft: false,
            isActive: false,
            names: {
                hr: "",
                en: "",
            },
            descriptions: {
                hr: "",
                en: "",
            },
            link: "",
            image: FileContentFactory.create(),
        }
    }
}
